import { render } from "./mode-toggle-switch.vue?vue&type=template&id=486a8385"
import script from "./mode-toggle-switch.vue?vue&type=script&lang=js"
export * from "./mode-toggle-switch.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__